import {generateResult} from '@/api/blindFundus'

export function getGenerateResult(params, that) {
  that.createLoading = true
  generateResult(params).then(res => {
    if (res && res.success) {
      const data = res.data
      if (data.is_finish) {
        if (data.is_success) {
          that.createLoading = false
          that.$message({
            message: '操作成功',
            type: 'success'
          })
          that.cancelDenerate()
        } else {
          that.createLoading = false
          that.$message(data.msg)
        }
      } else {
        setTimeout(function () {
          getGenerateResult(params, that)
        }, 2000)
      }
    } else {
      that.createLoading = false
      that.$message(res.msg)
    }
  }).catch(res => {
    that.createLoading = false
  })
}
